var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i18n',{staticClass:"card-text text-secondary",attrs:{"path":"customerService.text","tag":"p"}},[_c('CustomerServiceEmail'),_c('CustomerServicePhone')],1)}
var staticRenderFns = []

export { render, staticRenderFns }